<div class="main mt-sm-0 mt-5 mb-3">
    <form [formGroup]="userInputForm" [ngStyle]="{'cursor': isFormDisable ? 'not-allowed' : ''}">
        <div class="form-group">
            <div *ngFor="let inputData of inputDataList; let i = index" class="card card-body shadow"
                style="margin-bottom : 8px;" [id]="i">

                <div style="display: flex;">
                    <!-- <div *ngIf="i==0 && formName == 'detailedRegister'" class="iconContainer">
                        <i class="fa fa-arrow-left" (click)="backIconClick()" style="cursor: pointer;"></i>
                    </div> -->
                    <div class="heading">
                        {{heading[i]?.title}}
                    </div>
                </div>

                <p class="sub-title" *ngIf="!isFormDisable" style="font-weight: 500;">
                    {{heading[i]?.subTitle}}
                </p>

                <div *ngFor="let sectionData of inputData; let j=index;"
                    [ngStyle]="{'display' : sectionData.hide ? 'none' : 'block'}">

                    <div *ngIf="sectionData?.controllerName !== 'otp' && !isFormDisable">
                        <ng-template #defaultField>
                            <div style="display: flex;"
                                *ngIf="sectionData.type == 'text' || sectionData.type == 'number' || sectionData.type == 'email'">

                                <!-- Salutation -->
                                <div *ngIf="sectionData.controllerName == 'facility_owner_name' || sectionData.controllerName == 'lead_dr_name'"
                                    class="salutationBoX">
                                    <div class="salutationText">Salutation</div>
                                    <select style="height: 100%; font-weight: 500; padding-top:22px;"
                                        (change)="salutationChange($event.target.value)"
                                        formControlName="facility_salutation"
                                        [attr.disabled]="isSalutationDisable ? 'true' : null">
                                        <option value="">Select</option>
                                        <option *ngFor="let item of salutation" [name]="item" [value]="item">
                                            {{item}}
                                        </option>
                                    </select>
                                    <div *ngIf="userInputForm.controls['facility_salutation'].touched && !userInputForm.controls['facility_salutation'].valid"
                                        class="errorMsg">Please Select</div>
                                </div>

                                <!-- Form Input Fields -->
                                <!-- formField -->
                                <!-- <div [ngclass]="sectionData?.isDisable ? 'requiredFields' : 'requiredFields'"
                                    style="width: 100%;"> -->
                                <div [ngClass]="sectionData?.isDisable ? 'matParent corsorNone' : 'matParent' "
                                    style="width: 100%;">
                                    <mat-form-field class="mt-1"
                                        [ngClass]="sectionData?.isDisable ? 'form-field custom-mat-disable' : 'form-field' "
                                        appearance="outline">
                                        <!-- appearance="fill" -->
                                        <mat-label class="matLabel">
                                            {{sectionData?.label}}
                                            <sup>
                                                <i class="fa fa-asterisk asteric" *ngIf="sectionData.required"></i>
                                            </sup>

                                        </mat-label>
                                        <div class="matFormField"
                                            [ngStyle]="{'position' : sectionData?.type == 'email'? 'relative' : 'none'}">
                                            <div *ngIf="sectionData.type !== 'singleSelect'">
                                                <input [type]="sectionData?.type" matInput
                                                    [formControlName]="sectionData.controllerName"
                                                    [name]="sectionData.controllerName"
                                                    [id]="sectionData.controllerName"
                                                    [placeholder]="sectionData?.placeholder" style="position: relative;"
                                                    (input)="checkInput($event, sectionData)"
                                                    [maxlength]="sectionData?.maxlength">
                                            </div>

                                            <!-- <div *ngIf="sectionData.type !== 'singleSelect'">

                                            </div> -->

                                            <div class="emailVerify"
                                                *ngIf="sectionData?.type == 'email' && showVerify && formName =='facilityRegister'"
                                                (click)="emailVerifyClick()">Verify</div>
                                            <div class="emailVerify"
                                                *ngIf="sectionData?.type == 'email' && showResendOtp && formName =='facilityRegister'"
                                                (click)="emailVerifyClick()">Resend OTP</div>
                                            <div *ngIf="sectionData?.type == 'email' && formName =='facilityRegister' && showResendOTPEnable"
                                                class="resendEnableText">
                                                You are allow to resend the OTP after {{resendSecLeft}} seconds</div>

                                        </div>
                                        <mat-error
                                            style="margin-bottom: 20px;">{{getErrorMessage(sectionData)}}</mat-error>
                                    </mat-form-field>
                                    <div class="checkboxOption"
                                        *ngIf="formName =='detailedRegister' && (sectionData.controllerName == 'email_user_manyata' ||  sectionData.controllerName == 'mobile')">
                                        <div style="display: flex; align-items:center">
                                            <input type="checkbox" [disabled]="isFormDisable"
                                                [formControlName]="sectionData.controllerName == 'email_user_manyata' ? 'is_poc_email_check' : 'is_mobile_check'"
                                                [id]="sectionData.controllerName+(i+j)"
                                                [name]="sectionData.controllerName" style="cursor:pointer;"
                                                (change)="handleCheckPrevious(sectionData.controllerName+(i+j), sectionData.controllerName)">
                                            <span style="margin-left:4px">Same as the provided previously</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- <div *ngIf="userInputForm.get('sectionData?.controllerName').hasError('required') && isSubmited">This is required field</div> -->

                            <!-- <div *ngIf="sectionData.type == 'radio'">
                                <label [id]="sectionData.controllerName">{{sectionData.label}}</label>
                                <mat-radio-group
                                    [formControlName]="sectionData.controllerName">
                                    <mat-radio-button *ngFor="let option of sectionData.option" [value]="option.value">
                                        {{option.name}}
                                    </mat-radio-button>
                                </mat-radio-group>
                            </div> -->

                            <!-- Radio -->
                            <div *ngIf="sectionData.type == 'radio'" style="margin-top: 15px; margin-bottom: 20px;">
                                <div class="fieldLabel matLabel">
                                    {{sectionData.label}}
                                    <sup>
                                        <i class="fa fa-asterisk asteric" *ngIf="sectionData.required"></i>
                                    </sup>
                                </div>

                                <div style="display: flex; justify-content:space-between; width:15%; margin-left:12px;">
                                    <div class="optionContainer"
                                        *ngFor="let option of sectionData.option; let idx=index;"
                                        style="cursor: pointer;">
                                        <!-- <input type="radio" [id]="option.value" [name]="sectionData.controllerName" [value]="option.value" [formControlName]="sectionData.controllerName" (change)="setRadioControlleerName(sectionData.controllerName, option.value)"> -->
                                        <input type="radio" [id]="option.value" [name]="sectionData.controllerName"
                                            [value]="option.value" [formControlName]="sectionData.controllerName"
                                            (change)="changeRadio(sectionData.controllerName, option.value)"
                                            [ngStyle]="{'margin-left': idx == 1 ? '20px': ''}">
                                        <label class="optionLabel" for="html"> {{option.name}}</label>
                                    </div>
                                </div>
                                <div *ngIf="userInputForm.controls[sectionData.controllerName].touched && !userInputForm.controls[sectionData.controllerName].valid"
                                    class="errorMsg">Please Select Yes/No</div>
                            </div>

                            <!-- Single Select -->
                            <div *ngIf="sectionData.type == 'singleSelect'" style="margin-bottom: 20px;">


                                <div class="fieldLabel matLabel">
                                    {{sectionData.label}}
                                    <sup>
                                        <i class="fa fa-asterisk asteric" *ngIf="sectionData.required"></i>
                                    </sup>
                                </div>
                                <div [ngClass]="sectionData?.isDisable ? 'disableInput' : '' ">
                                    <select (change)="selectChange(sectionData.controllerName, $event.target.value)"
                                        [formControlName]="sectionData.controllerName">
                                        <option value="">Please Select</option>
                                        <option *ngFor="let obj of sectionData.option" [name]="obj.name"
                                            [value]="obj.value">
                                            {{obj.name}}
                                        </option>
                                    </select>
                                </div>
                                <div *ngIf="userInputForm.controls[sectionData.controllerName].touched  && !userInputForm.controls[sectionData.controllerName].valid"
                                    class="errorMsg">Please Select {{sectionData.errorMsg}}</div>

                                <!-- <mat-form-field [ngClass]="sectionData?.isDisable ? 'disableInput' : '' "
                                    appearance="outline">
                                    <mat-label>{{sectionData.label}}
                                        <sup>
                                            <i class="fa fa-asterisk asteric" *ngIf="sectionData.required"></i>
                                        </sup>
                                    </mat-label>
                                    <mat-select (change)="selectChange(sectionData.controllerName, $event.target.value)"
                                        [formControlName]="sectionData.controllerName">
                                        <mat-option  *ngFor="let obj of sectionData.option" [value]="obj.value">
                                            {{obj.name}}
                                        </mat-option>
                                    </mat-select>
                                    <mat-error *ngIf="userInputForm.controls[sectionData.controllerName].touched  && !userInputForm.controls[sectionData.controllerName].valid">Please Select {{sectionData.errorMsg}}</mat-error>
                                </mat-form-field> -->
                            </div>

                            <!-- <div *ngIf="sectionData.type == 'toggle'" style="margin-bottom: 20px;">
                                <mat-slide-toggle [formControlName]="sectionData.controllerName">Slide me!</mat-slide-toggle>
                            </div> -->
                        </ng-template>

                        <!-- Terms and Condition -->
                        <div class="termsCondition"
                            *ngIf="showTermsCondition && sectionData?.controllerName == 'tnc'; else defaultField">
                            <input type="checkbox" (click)="checkTermsCons()" id="termsCondition" name="termsCondition"
                                value="termsCondition">
                            <div class="tc" style="margin-left:5px">By clicking create account, I agree to
                                <span style="color:#ED1556; font-weight:600; cursor:pointer;"
                                    (click)="openTermsConditionDialog()">terms and
                                    conditions</span>
                            </div>
                        </div>
                    </div>

                    <!-- OTP Verification -->
                    <div *ngIf="sectionData?.controllerName == 'otp' && !isFormDisable">
                        <div *ngIf="showOtpInput" style="padding-bottom: 1.34375em; margin: 0.25em 0;">
                            <div class="otp" style="font-weight: 600; margin-left:2px">OTP Verification</div>
                            <div style="display: flex; margin-top: 5px;">
                                <input type="number" value="" *ngFor="let item of otpBox" [id]="item" class="otpBox"
                                    (input)="otpInput($event)" maxlength="1" (paste)="handlePaste()">
                            </div>
                        </div>
                    </div>


                    <!-- For View Only Page -->
                    <div *ngIf="isFormDisable" class="viewOnlyFieldContainer"
                        [ngStyle]="{'border-top':  j != 0 ? '1px solid rgb(207, 206, 206)' : ''}">
                        <div class="viewOnlyLabel">{{sectionData?.label}}</div>
                        <div class="viewOnlyValue">
                            <div *ngIf="sectionData?.type == 'singleSelect'">
                                <!-- {{userInputForm.get(sectionData?.controllerName)?.value !== "" ?
                                sectionData?.option[userInputForm.get(sectionData?.controllerName)?.value-1]?.name
                                : 'N/A'}} -->
                                {{userInputForm.get(sectionData?.controllerName)?.value !== "" ?
                                sectionData?.controllerName == 'ref_cse_id' ?
                                reffered_cse_name:
                                sectionData?.option[userInputForm.get(sectionData?.controllerName)?.value-1]?.name
                                : 'N/A'}}
                            </div>
                            <div *ngIf="sectionData?.type == 'radio'">
                                {{userInputForm.get(sectionData.controllerName).value !== "" ?
                                userInputForm.get(sectionData.controllerName).value == 1 ? 'Yes' : 'No'
                                : 'N/A'}}
                            </div>
                            <!-- <div *ngIf="sectionData?.type == 'payment'">
                                <div style="display:flex; align-items:center; font-weight:600;"
                                    [ngStyle]="{'color': paymentStatus == 'Completed' ? '#19B123' : '#F09329' }">
                                    <span style="margin-right:5px;">
                                        {{paymentStatus}}
                                    </span>

                                    <svg *ngIf="paymentStatus == 'Completed'" id="Group_16600" data-name="Group 16600"
                                        xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                        <path id="Path_6343" data-name="Path 6343" d="M0,0H24V24H0Z" fill="none" />
                                        <path id="Path_6344" data-name="Path 6344"
                                            d="M12,22A10,10,0,1,1,22,12,10,10,0,0,1,12,22Zm-1-6,7.07-7.071L16.659,7.515,11,13.172,8.174,10.343,6.76,11.757Z"
                                            fill="#19b123" />
                                    </svg>

                                    <svg  *ngIf="paymentStatus == 'Pending'" xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24"
                                        height="24px" viewBox="0 0 24 24" width="24px" fill="#F09329">
                                        <g>
                                            <rect fill="none" height="24" width="24" />
                                            <path
                                                d="M17,12c-2.76,0-5,2.24-5,5s2.24,5,5,5c2.76,0,5-2.24,5-5S19.76,12,17,12z M18.65,19.35l-2.15-2.15V14h1v2.79l1.85,1.85 L18.65,19.35z M18,3h-3.18C14.4,1.84,13.3,1,12,1S9.6,1.84,9.18,3H6C4.9,3,4,3.9,4,5v15c0,1.1,0.9,2,2,2h6.11 c-0.59-0.57-1.07-1.25-1.42-2H6V5h2v3h8V5h2v5.08c0.71,0.1,1.38,0.31,2,0.6V5C20,3.9,19.1,3,18,3z M12,5c-0.55,0-1-0.45-1-1 c0-0.55,0.45-1,1-1c0.55,0,1,0.45,1,1C13,4.55,12.55,5,12,5z" />
                                        </g>
                                    </svg>
                                </div>
                            </div> -->
                            <div
                                *ngIf="sectionData?.type !== 'singleSelect' && sectionData?.type !== 'radio'  && sectionData?.type !== 'payment'">
                                {{userInputForm.get(sectionData.controllerName).value !== "" ?
                                userInputForm.get(sectionData.controllerName).value
                                :'N/A'}}
                            </div>
                        </div>
                    </div>
                </div>


                <!-- Buttons -->
                <div [ngClass]="submitBtnText == 'CREATE ACCOUNT' ? '' : 'buttonContainer'"
                    *ngIf="i == inputDataList.length-1 && !isFormDisable">

                    <!-- Cancel Button -->
                    <button type="button" (click)="cancelForm()" *ngIf="showCancelBtn" class="cancelBtn">
                        {{CancelBtnText}}</button>

                    <!-- Draft Button -->
                    <button type="button" (click)="draftForm()" *ngIf="showDraftBtn"
                        class="draftBtn">{{DraftBtnText}}</button>

                    <!-- Submit Button -->
                    <button type="button" (click)="submitForm()" *ngIf="showSubmitBtn && formName != 'facilityRegister'"
                        [style]="submitBtnText == 'CREATE ACCOUNT' ? '' : 'margin-left:15px'" class="submitBtn">
                        <!-- [ngClass]="userInputForm.status == 'VALID' ? 'submitBtn' : 'disableSubmitBtn'"> -->
                        {{submitBtnText}}</button>

                    <button type="button" (click)="submitForm()" *ngIf="showSubmitBtn && formName == 'facilityRegister'"
                        [style]="submitBtnText == 'CREATE ACCOUNT' ? '' : 'margin-left:15px'"
                        [ngClass]="userInputForm.status == 'VALID' ? 'submitBtn' : 'disableSubmitBtn'">
                        {{submitBtnText}}
                    </button>
                </div>
            </div>


            <!-- For Payment Information Card (Show only in view only page) -->
            <div *ngIf="isFormDisable" class="card card-body shadow">
                <div class="heading">
                    Purchased Information
                </div>

                <div class="paymentLabels">
                    <div class="label">
                        <span>Payment Status</span>
                    </div>

                    <div style="display:flex; align-items:center; font-weight:600;"
                        [ngStyle]="{'color': paymentStatus == 'Completed' ? '#19B123' : '#F09329'}">
                        <span style="margin-right:5px; font-size:14px;">
                            {{paymentStatus}}
                        </span>

                        <!-- <svg *ngIf="paymentStatus == 'Completed'" id="Group_16600" data-name="Group 16600"
                            xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                            <path id="Path_6343" data-name="Path 6343" d="M0,0H24V24H0Z" fill="none" />
                            <path id="Path_6344" data-name="Path 6344"
                                d="M12,22A10,10,0,1,1,22,12,10,10,0,0,1,12,22Zm-1-6,7.07-7.071L16.659,7.515,11,13.172,8.174,10.343,6.76,11.757Z"
                                fill="#19b123" />
                        </svg>

                        <svg *ngIf="paymentStatus == 'Pending'" xmlns="http://www.w3.org/2000/svg"
                            enable-background="new 0 0 24 24" height="24px" viewBox="0 0 24 24" width="24px"
                            fill="#F09329">
                            <g>
                                <rect fill="none" height="24" width="24" />
                                <path
                                    d="M17,12c-2.76,0-5,2.24-5,5s2.24,5,5,5c2.76,0,5-2.24,5-5S19.76,12,17,12z M18.65,19.35l-2.15-2.15V14h1v2.79l1.85,1.85 L18.65,19.35z M18,3h-3.18C14.4,1.84,13.3,1,12,1S9.6,1.84,9.18,3H6C4.9,3,4,3.9,4,5v15c0,1.1,0.9,2,2,2h6.11 c-0.59-0.57-1.07-1.25-1.42-2H6V5h2v3h8V5h2v5.08c0.71,0.1,1.38,0.31,2,0.6V5C20,3.9,19.1,3,18,3z M12,5c-0.55,0-1-0.45-1-1 c0-0.55,0.45-1,1-1c0.55,0,1,0.45,1,1C13,4.55,12.55,5,12,5z" />
                            </g>
                        </svg>

                        <svg *ngIf="paymentStatus == 'Pending For Approval'" xmlns="http://www.w3.org/2000/svg"
                            height="24" viewBox="0 96 960 960" width="24">
                            <path
                                d="m764 887 27-27-84-76V660h-42v135.776L764 887ZM480 566Zm-30-385q14.328-8 30.164-8Q496 173 510 181l300 173q14.25 8.426 22.125 22.213T840 406v157q-13.655-10.156-28.828-17.578Q796 538 780 532v-96l-149 87q-59 14-106.5 51T450 664v-71L180 437v309l265 153q10 21 23.5 40.5T499 976q-12 5-25 3.5t-24-8.5L150 798q-14.25-8.426-22.125-22.213T120 746V406q0-16 7.875-29.787Q135.75 362.426 150 354l300-173Zm30 52L213 387l267 155 266-155-266-154Zm210 743q-78 0-134-55.399-56-55.4-56-134Q500 708 556 652t134-56q78 0 134 55.867Q880 707.735 880 787q0 78.435-56 133.718Q768 976 690 976Z"
                                fill="#e8f007" />
                        </svg>


                        <svg *ngIf="paymentStatus == 'Partially Completed'" xmlns="http://www.w3.org/2000/svg"
                            height="24" viewBox="0 96 960 960" width="24">
                            <path
                                d="M447 976q-82 0-155-31.5t-127.5-86Q110 804 78.5 731T47 576q0-83 31.5-156t86-127Q219 239 292 207.5T447 176q83 0 156 31.5T730 293q54 54 85.5 127T847 576q0 82-31.5 155T730 858.5q-54 54.5-127 86T447 976Zm305-250H338l-60 60h436q11-14 20.5-29t17.5-31Zm34-120H459l-61 60h377q4-14 6.5-29t4.5-31Zm-11-120H579l-60 60h267q-2-16-4.5-31t-6.5-29Zm-67-128-68 68h112q-9-19-20-35.5T708 358ZM186 794l480-478q-45-38-100.5-59T447 236q-141 0-240.5 99T107 576q0 63 21 118t58 100Zm261 122q59 0 111-18.5t95-51.5H241q43 33 95.5 51.5T447 916Z"
                                fill="#114cf0" />
                        </svg> -->
                    </div>
                </div>

                <div class="paymentLabels">
                    <div class="label">
                        <span>Total Amount</span>
                    </div>
                    <div style="font-weight:500; display:flex; align-items:center;"><span>₹</span>
                        <span>{{totalAmountToPaid}}</span>
                    </div>
                </div>

                <div class="amountPaidBalance">
                    <div>
                        <div class="label">
                            <span>Amount Paid</span>
                        </div>
                        <div style="color:#19B123; font-weight:500; display:flex; align-items:center;"><span>₹</span>
                            <span>{{amountPaidTillNow}}</span>
                        </div>
                    </div>
                    <div style="margin-left: 4rem;">
                        <div class="label">
                            <span>Amount Pending</span>
                        </div>
                        <div style="color:#f53333; font-weight:500; display:flex; align-items:center;"><span>₹</span>
                            <span> {{pendingAmount >=1 ? pendingAmount : 0}}</span>
                        </div>
                    </div>
                </div>

                <div *ngIf="isPaymentRejected" class="paymentLabels">
                    <div class="label">
                        <span>Payment Reason Of Rejection</span>
                    </div>
                    <div style="font-weight:500;">{{paymentRejectionReason}}</div>
                </div>

                <div *ngIf="isPaymentApprovedRemarks" class="paymentLabels">
                    <div class="label">
                        <span>Payment Approved Remark</span>
                    </div>
                    <div style="font-weight:500;">{{paymentApprovedRemarks}}</div>
                </div>

                <div *ngIf="isAdminLogin" style="margin-top:10px">
                    <div class="label">
                        <span>Payment Receipts</span>
                    </div>
                    <div style="display: flex;" class="receiptContainer">
                        <div *ngFor="let paymentObj of paymentDetails; let i = index" style="cursor: pointer;"
                            [ngStyle]="{'margin-left': i !== 0 ? '10px' : ''}" (click)="openReceiptDialog(paymentObj)">
                            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 18 20">
                                <path id="Path_6967" data-name="Path 6967"
                                    d="M21,9V20.993A1,1,0,0,1,20.007,22H3.993A.993.993,0,0,1,3,21.008V2.992A1,1,0,0,1,4,2H14V8a1,1,0,0,0,1,1Zm0-2H16V2ZM8,7V9h3V7Zm0,4v2h8V11Zm0,4v2h8V15Z"
                                    transform="translate(-3 -2)" fill="#ED1556" />
                            </svg>
                        </div>
                    </div>
                </div>

                <div class='buttonContainer'
                    *ngIf="paymentStatus != 'Pending For Approval' && paymentStatus !== 'Completed' && !isAdminLogin && userProfileUpdated">
                    <button type="button" (click)="payLaterClick()" class="draftBtn">
                        PAY LATER
                    </button>

                    <button type="button" (click)="makePayment()" style='margin-left:15px' class="submitBtn">
                        MAKE PAYMENT
                    </button>
                </div>
            </div>
        </div>

        <!-- <div class="termsCondition" *ngIf="showTermsCondition">
            <input type="checkbox" (change)="isCheckTermsCon ? isCheckTermsCon = false :  isCheckTermsCon = true"
                id="termsCondition" name="termsCondition" value="termsCondition">
            <div style="margin-left:5px">By clicking create account, I agree to
                <span style="color:#ED1556; font-weight:600; cursor:pointer;">terms and conditions</span>
            </div>
        </div> -->

        <div class="spinnerLoader">
            <!-- <mat-progress-spinner mode="indeterminate"></mat-progress-spinner> -->
        </div>
    </form>
</div>